/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// Shrink Shopify Inbox live chat button (PC + mobile)
(function () {
  var s = document.createElement('style');
  s.id = 'ky-chat-resize';
  s.textContent = '#ShopifyChat{transform:scale(0.7);transform-origin:bottom right;}';
  document.head.appendChild(s);
})();
